export default __webpack_public_path__ + "static/media/EuclidSquare-Medium.8026c8db.woff";